import store from "../store";

export const rundownLock = (locked) => {
	return store.dispatch({
		type: "RUNDOWN_LOCK",
		locked,
	});
};

export const cueToEdit = (cue, editing) => {
	return store.dispatch({
		type: "CUE_TO_EDIT",
		cue,
		editing,
	});
};
